export default __webpack_public_path__ + "static/media/bonded_warehouse.94f78888.svg";